/* tslint:disable */
/* eslint-disable */
export enum PartnerServiceProduktEnum {
  Gas = 'Gas',
  GasStorbraender = 'GasStorbraender',
  Olie = 'Olie',
  Varmepumpe = 'Varmepumpe'
}
